import { IConfig } from '@williamhill/rosi-ui-shared/src/types';

type Config = Required<Pick<IConfig, 'APP'>> & {
  AWS: {
    waf_url: string;
    captcha_url: string;
    domain_list: string[];
    api_key: string;
  };
  REGION: string;
  STATE: string;
  BET_TRACKER_CONFIG_FILE: string;
  BRANDING: string;
  basePath: string;
  URLS: {
    aw_api: string;
  };
  build: {
    version: string;
  };
};

const defaultConfig: Config = {
  APP: 'BET-TRACKER',
  AWS: {
    waf_url: 'https://4ad3fec456d9.edge.sdk.awswaf.com/4ad3fec456d9/4bccfb2d68a0/challenge.js',
    captcha_url: 'https://4ad3fec456d9.edge.captcha-sdk.awswaf.com/4ad3fec456d9/jsapi.js',
    domain_list: ['.williamhill-test.com', '.l5y.app'],
    api_key:
      'kD3l6kk/O8ZF/YorwKqmgmhJD3RXoLbDli6Id5/NxWrEeWA5iHywLO0RpoqsLXGd6ldpFUDGU6w8CUCLsSRgd3oChDHd8zQUrJoKjEFwZGtDJx3aNSXGZl8MeMqFCDpuJ4j07FGZ5io824vPUlSS+DrZl0YD004PnKFEGqEpjScU8GjPqnmmhX1had2lj2mNASvt2NUQiEbbmzJ0eAZEvB/pe8W6yjmaL9LXysS8gY8oGTtEJKqKgZFUtm6WexI1YhpRLsSPw0zQciqjCnv2BDRju6iJOHMPAohf8qCcjmMPwp9z+PMcJFPMG8sygIeCyD4Y24GDefH7X653dPkIEZNJdqwbT/qQCBZX+pJjaSI+mhwuOhswJz+m/Kyb0M2kHMD9emP+F1rMDeNrOS6PDdGovhBNutsasMju4feLfEGmXevzUgS7vV33eAnHEESe48cg4/4Jd+YFynCDVzqkdBEjK1po7aPKl+k6+CPlwp4UHncTVC6gDNTqbArM6+Hue6Aj4dYG6n4y0LN5yQtsVV2O4iXJUBUP2z01O/jhI1WHJKynTZp6ZlYJlLb+O72pp6mluR++NGAgicAODeSnATbkcQo/FHfkaMuVi6o9BB6EkP3L1S/ckGg6W5MLKIhwz/4XTDfr+Tk/wIP4YgWZsxKAz8FYvPSDCMXLJd+mSc4=_1_1'
  },
  basePath: '',
  BET_TRACKER_CONFIG_FILE: 'retail-bet-tracker-gpt.yml',
  BRANDING: 'CAESARS',
  REGION: 'us',
  STATE: 'wv',
  URLS: {
    aw_api: 'https://api.aw.gpt.l5y.app'
  },
  build: {
    version: '1.42.0'
  }
};

export default { ...defaultConfig, ...((window as any).ROSI as Config) };
